export default __webpack_public_path__ + "static/media/Create-documentation.d3e9c262.md";